export default __webpack_public_path__ + "static/media/switchBars.58506fc4.svg";